export class ListDataClassificationEntitiesResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dataClassificationEntities",
            "baseName": "dataClassificationEntities",
            "type": "Array<DataClassificationEntity>",
            "format": ""
        },
        {
            "name": "pagination",
            "baseName": "pagination",
            "type": "Pagination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDataClassificationEntitiesResponse.attributeTypeMap;
    }
    constructor() {
    }
}
